var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ov)?_c('span',{staticClass:"j-sensitive-wrap"},[_vm._v(" "+_vm._s(_vm.eyeStyle === 'close' ? _vm.nv : _vm.ov)+" "),(_vm.eye && _vm.ov)?_c('i',{class:`j-sensitive-eye-${_vm.eyeStyle}`,on:{"click":_vm.eyeChange}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }